import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ba from 'vue-ba';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/utils/flexlib';
import zh from '@/lang/zh.json';
import en from '@/lang/en.json';
import getLanguage from './utils/getLanguage';
import sensorPlugin from './plugins/sensorPlugin';
import isMac from './utils/isMac';
import baiduPlugin from './plugins/baiduPlugin';

Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(ba, 'c190e00bdb3bd57e36a734020aac3709');
Vue.use(sensorPlugin, 'https://strack.doviapps.com/sa?project=macclean-cn');
Vue.use(baiduPlugin);
Vue.prototype.$isMac = isMac;

const messages = {
  zh,
  en,
};
const i18n = new VueI18n({
  locale: getLanguage(),
  silentFallbackWarn: true,
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
